import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';
import OriginCountryJSON from 'src/assets/data/einvoice-origin-country.json';

@Component({
  selector: 'app-einvoice-origin-country-select',
  templateUrl: './einvoice-origin-country-select.component.html',
  styleUrls: ['./einvoice-origin-country-select.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ViewItemComponent
  ],
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceOriginCountrySelectComponent),
      multi: true
    }
  ]
})
export class EInvoiceOriginCountrySelectComponent
  implements ControlValueAccessor
{
  options = [...OriginCountryJSON];

  @Input() value: string = '';
  @Input() disabled = false;
  @Input() borderless = false;
  @Input() isRequired = false;
  @Input() showCountryCode = false;
  @Input() useLongCode = false;

  get readonly() {
    if (this.disabled) {
      return true;
    }
    return false;
  }

  get displayText() {
    if (this.useLongCode) {
      const item = this.options.find(x => x.longCode === this.value);
      if (item) return `${item.name}`;
    } else {
      const item = this.options.find(x => x.code === this.value);
      if (item) return `${item.name}`;
    }
    return '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
